import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { expVal } from '@atlassian/jira-feature-experiments';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import parameters from './__generated__/Nav4PlansListViewQuery.graphql';
import refactoredParameters from './__generated__/Nav4PlansListViewRefactoredQuery.graphql';

type EntryPointParams = { cloudId: string; accountId?: string; activationId?: string };

export const asyncPlansSectionPlanListViewQuery = createEntryPoint({
	root: JSResourceForInteraction(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(): Promise<any> => {
			// Feature gate to choose between original and refactored implementation
			if (expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
				return import(
					/* webpackChunkName: "async-projects-section-content-view-refactored-query" */ './Nav4PlansListViewRefactoredQuery'
				);
			}
			return import(
				/* webpackChunkName: "async-projects-section-content-view-query" */ './Nav4PlansListViewQuery'
			);
		},
	),
	getPreloadProps: (params: EntryPointParams) => {
		const cloudId = params.cloudId;
		if (expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
			const ownerAri = IdentityUserAri.create({
				userId: params.accountId || 'UNKNOWN',
			}).toString();
			const entityAri = JiraNavigationSettingsAri.create({
				siteId: cloudId,
				activationId: params.activationId || '',
				navigationSettingScope: 'plans',
			}).toString();
			return {
				queries: {
					queryRef: {
						parameters: refactoredParameters,
						variables: {
							cloudId,
							entityAriPlans: entityAri,
							ownerAri,
						},
					},
				},
			};
		}
		return {
			queries: {
				queryRef: {
					parameters,
					variables: {
						cloudId,
					},
				},
			},
		};
	},
});
